import {
  APP_INITIALIZER,
  EnvironmentProviders,
  Provider,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService, TranslationObject } from '@ngx-translate/core';
import { catchError, firstValueFrom, of } from 'rxjs';
import { UserSettingsModels } from '@share-models';

const shareOrganizationSettingsLangs = Object.values(
  UserSettingsModels.LANGUAGE,
) as UserSettingsModels.LANGUAGE[];

export function shareOrganizationSettingsTranslationsInitializer(
  translateService: TranslateService,
  http: HttpClient,
): () => Promise<void> {
  return () => {
    const requests = shareOrganizationSettingsLangs.map((lang) => {
      const url = `assets/share-organization-settings/i18n/${lang}.json`;
      return firstValueFrom(
        http
          .get<TranslationObject>(url)
          .pipe(catchError(() => of({} as TranslationObject))),
      ).then((translations) => {
        translateService.setTranslation(lang, translations ?? {}, true);
      });
    });

    return Promise.all(requests).then(() => undefined);
  };
}

export function provideShareOrganizationSettings(): (
  | Provider
  | EnvironmentProviders
)[] {
  return [
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: shareOrganizationSettingsTranslationsInitializer,
      deps: [TranslateService, HttpClient],
    },
  ];
}
